<template>
  <base-page-template>
    <v-container fluid>
      <v-card outlined class="elevation-0 mb-5">
        <v-card-title>確認と保存</v-card-title>
        <v-card-subtitle>
          <p>入力した内容を確認後、保存してください。</p>
          <error-panel :errors="errorsView" small></error-panel>
        </v-card-subtitle>

        <div style="position: absolute; right: 20px; bottom: 20px;">
          <v-btn
              color="primary"
              x-large
              @click="save()">
            保存
          </v-btn>
        </div>
      </v-card>

      <trade-contract-view-panel
          :trade-contracts="tradeContracts"
          hide-trade-contract-info
          hide-other-data-profile
          hide-messages
          activate
      >
        <template #self-data-profile-title>
          発行側データプロファイル
        </template>
        <template #self-service-profile-title>
          発行側サービスプロファイル
        </template>
        <template #after-other-service-profile="{tradeContract}">
          <companion-service-component-model-info :trade-contract="tradeContract"/>
        </template>
      </trade-contract-view-panel>

      <v-row justify="center" class="my-10">
        <v-btn
            color="primary"
            x-large
            @click="save()">
          保存
        </v-btn>
      </v-row>
    </v-container>

    <app-header :errors="errorsView">
      <error-panel :errors="errorsView" small></error-panel>
    </app-header>
  </base-page-template>
</template>

<script>
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import {mapGetters} from "vuex";
import Formatter from "@/utils/Formatter";
import TradeContractViewPanel from "@/components/pages/contract/TradeContract/TradeContractViewPanel.vue";
import ErrorPanel from "@/components/molecules/ErrorPanel.vue";
import AppHeader from "@/components/atoms/AppHeader.vue";
import CompanionServiceComponentModelInfo
  from "@/components/pages/contract/TradeContractFormat/CompanionServiceComponentModelInfo.vue";

export default {
  name: "Complete",
  components: {
    CompanionServiceComponentModelInfo,
    AppHeader, ErrorPanel, TradeContractViewPanel, BasePageTemplate},
  mixins: [Formatter],
  props: {
    tradeContracts: {
      type: Array,
      required: true
    },
    errors: {
      type: Array,
      default: () => ([])
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$watch(
        () => this.tradeContract.id,
        tradeContractId => {
          if(tradeContractId) {
            this.load();
          }
        },
        { immediate: true }
    );
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
    tradeContract() {
      return this.tradeContracts[0];
    },
    errorsView() {
      return this.errors.slice();
    }
  },
  methods: {
    async load() {
      return;
    },
    async save() {
      this.$emit('save');
    },
    isTransitButtonEnabled(button) {
      // 中断ボタンは常に押下可
      if(button.requestType === 'save') {
        return true;
      }
      // メッセージが未入力の場合は全ボタン押下不可
      if(!this.tradeContract.message) {
        return false;
      }
      // complete フラグの立っているボタンは completable と同期する
      if(button.complete) {
        return this.completable;
      }
      // complete フラグの立っていないボタンは常に押下可
      return true;
    },
  },
}
</script>

<style lang="scss" scoped>
$el-override-color: rgba(0, 0, 0, 0.42);
$el-override-emphasis-color: rgba(0, 0, 0, 0.87);
$el-override-placeholder-color: rgb(96, 98, 102);

::v-deep .el-date-editor {
  .el-input__inner {
    border-color: $el-override-color;
    color: $el-override-emphasis-color;

    &::placeholder {
      color: $el-override-placeholder-color;
    }

    &:hover {
      border-color: $el-override-emphasis-color;
    }
  }

  // エラーの場合に赤くする
  &.has-error .el-input__inner {
    border-color: rgb(180,0,0);
    box-shadow: 0 0 5px rgb(220 0 0 / 50%);
  }

  &.el-date-editor--datetimerange {
    border-color: $el-override-color;

    .el-range__icon {
      color: $el-override-emphasis-color;
    }

    .el-range-input {
      color: $el-override-emphasis-color;

      &::placeholder {
        color: $el-override-placeholder-color;
      }
    }

    &:hover {
      border-color: $el-override-emphasis-color;
    }
  }

  .el-input__prefix {
    color: $el-override-placeholder-color;
  }
}

.row.form-row {
  .col {
    width: fit-content;
    flex-grow: initial;
  }

  label {
    margin-right: 1rem;
    white-space: nowrap;
    align-self: center;
  }
}

.v-application .v-chip.el-date-picker-like {
  width: 220px;
  height: 40px;
  border-color: rgba(0, 0, 0, 0.42) !important;

  &:hover {
    border-color: rgba(0, 0, 0, 0.87) !important;
  }
  &:hover:before {
    opacity: 0;
  }
}

.message-textarea ::v-deep textarea {
  margin-top: 16px !important;
  margin-bottom: 8px;
}

</style>
